import { __decorate } from "tslib";
import { observable, action } from 'mobx';
var RunningState;
(function (RunningState) {
    RunningState[RunningState["Stopped"] = 0] = "Stopped";
    RunningState[RunningState["Starting"] = 1] = "Starting";
    RunningState[RunningState["Started"] = 2] = "Started";
    RunningState[RunningState["Stopping"] = 3] = "Stopping";
})(RunningState || (RunningState = {}));
var StoreLoadingBarHelpers = /** @class */ (function () {
    function StoreLoadingBarHelpers() {
        /**Loading bar progress value between 0 and 100 */
        this.Progress = 0;
        /**Loadin black display class */
        this.DisplayClass = '';
        /**Block content loading display class */
        this.BlockContentDisplayClass = '';
        /**Loading bar state */
        this.CurrentState = RunningState.Stopped;
        /**Store interval loop */
        this.Interval = null;
    }
    /**Show and start loading bar progress */
    StoreLoadingBarHelpers.prototype.Show = function () {
        if (this.CurrentState === RunningState.Stopped) {
            this.CurrentState = RunningState.Starting;
            this.BlockContentDisplayClass = '';
            this.Progress = 20;
            this.Loop();
        }
    };
    /**Add progress to the loading bar */
    StoreLoadingBarHelpers.prototype.Loop = function () {
        var _this = this;
        this.CurrentState = RunningState.Started;
        this.Interval = setInterval(function () {
            if (_this.Progress < 90) {
                _this.Progress += Math.floor(Math.random() * 8 + 2);
            }
        }, 1000);
    };
    /**Complete and hide loading bar */
    StoreLoadingBarHelpers.prototype.Hide = function () {
        if (this.CurrentState !== RunningState.Stopped) {
            this.ClearInterval();
            this.CurrentState = RunningState.Stopping;
            this.Progress = 100;
            this.BlockContentDisplayClass = 'd-none';
            this.BackGroundHide();
        }
    };
    /**Reset loading bar to 0 value */
    StoreLoadingBarHelpers.prototype.BackGroundHide = function () {
        var _this = this;
        setTimeout(function () {
            _this.Progress = 0;
            _this.DisplayClass = 'd-none';
            _this.ResetState();
        }, 750);
    };
    /**Reset loading bar to initial state */
    StoreLoadingBarHelpers.prototype.ResetState = function () {
        var _this = this;
        setTimeout(function () {
            _this.CurrentState = RunningState.Stopped;
            _this.DisplayClass = '';
        }, 100);
    };
    /**Clear interval */
    StoreLoadingBarHelpers.prototype.ClearInterval = function () {
        if (this.Interval !== null) {
            clearInterval(this.Interval);
            this.Interval = null;
        }
    };
    __decorate([
        observable
    ], StoreLoadingBarHelpers.prototype, "Progress", void 0);
    __decorate([
        observable
    ], StoreLoadingBarHelpers.prototype, "DisplayClass", void 0);
    __decorate([
        observable
    ], StoreLoadingBarHelpers.prototype, "BlockContentDisplayClass", void 0);
    __decorate([
        action
    ], StoreLoadingBarHelpers.prototype, "Show", null);
    __decorate([
        action
    ], StoreLoadingBarHelpers.prototype, "Loop", null);
    __decorate([
        action
    ], StoreLoadingBarHelpers.prototype, "Hide", null);
    __decorate([
        action
    ], StoreLoadingBarHelpers.prototype, "BackGroundHide", null);
    __decorate([
        action
    ], StoreLoadingBarHelpers.prototype, "ResetState", null);
    return StoreLoadingBarHelpers;
}());
var StoreLoadingBar = new StoreLoadingBarHelpers();
export default StoreLoadingBar;
//# sourceMappingURL=StoreLoadingBar.js.map